import React, { FC, useState } from "react";
import {
  Dialog,
  Grid,
  Button,
  CircularProgress,
  DialogProps,
  makeStyles,
} from "@material-ui/core";
import { DialogHeader } from "./dialog-header";
import roundedButtonStyle from "styles/buttons/rounded-button.module.scss";
import { useSelector } from "react-redux";
import { GetUrlBuilderData } from "store/url-builder";
import { theme } from "material-theme";

const useStyles = makeStyles(() => ({
  root: {
    maxWidth: (props: any) => props.width,
    height: (props: any) => props.height,
  },
}));

export enum DialogWrapperType {
  DEFAULT = "DEFAULT",
  DELETE = "DELETE",
  SUBMIT = "SUBMIT",
}

export interface DialogWrapperProps extends DialogProps {
  open: boolean;
  loading?: boolean;
  title?: string;
  onSubmit?(): void;
  type?: DialogWrapperType;
  onDelete?(): void;
  width?: any;
  height?: any;
  enableFullScreen?: boolean;
  disableSave?: boolean;
  headerDivider?: boolean;
  submitText?: string;
  error?: boolean;
}

export const DialogWrapper: FC<DialogWrapperProps> = ({
  children,
  onClose,
  title,
  loading = false,
  onSubmit,
  onDelete,
  enableFullScreen,
  type = DialogWrapperType.SUBMIT,
  disableSave = false,
  headerDivider,
  submitText = "Save",
  error = false,
  ...rest
}) => {
  const builderData = useSelector(GetUrlBuilderData);
  const [fullScreen, setFullScreen] = useState(false);
  if (fullScreen) rest.height = "87vh";
  const style = useStyles(rest);

  return (
    <Dialog onClose={onClose} {...rest} scroll="body" fullScreen={fullScreen}>
      <Grid
        container
        item
        xs={12}
        style={{ margin: 0, padding: ".5em 1em" }}
        spacing={3}
        justifyContent="center"
      >
        {title && (
          <Grid item xs={12}>
            <DialogHeader
              title={title}
              onClose={onClose}
              enableFullScreen={enableFullScreen}
              fullScreen={fullScreen}
              setFullScreen={setFullScreen}
              divider={headerDivider}
              loading={loading}
            />
          </Grid>
        )}
        <Grid
          item
          container
          xs={12}
          className={style.root}
          style={fullScreen ? { overflowY: "scroll" } : {}}
        >
          {children}
        </Grid>
        <Grid item xs={12} container>
          {type === DialogWrapperType.DELETE && (
            <Grid item xs>
              <Button
                className={roundedButtonStyle.root}
                onClick={onDelete}
                variant="contained"
                style={{
                  backgroundColor: "#fb3535",
                  borderColor: "#fb3535",
                  color: "#fff",
                }}
              >
                Delete
              </Button>
            </Grid>
          )}
          {type === DialogWrapperType.SUBMIT && (
            <Grid item xs>
              <Button
                className={roundedButtonStyle.root}
                onClick={onSubmit}
                style={{
                  backgroundColor: error
                    ? "#c82333"
                    : builderData.primaryColor.color ||
                      theme.palette.primary.main,
                  color: "#fff",
                }}
                size="large"
                variant="contained"
                fullWidth
                disabled={loading || disableSave}
              >
                {loading ? <CircularProgress size={24} /> : submitText}
              </Button>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Dialog>
  );
};
